<template>
  <div class="signUpForm">
    <div style="color:red;padding:6px;line-height:25px;">1、本网站已经接入实名认证系统，请认真准确的填写个人信息，确保姓名、身份证等信息的准确性，否则影响后期的赛事报名和装备领取，由此带来的损失自行负责！</div>
    <div style="color:red;padding:0 5px 5px;line-height:25px;">2、需要帮他人报名，请用另外的手机号重新登陆，一个手机号只能报一个人，否则影响报名审核和付款！</div>

    <van-form @submit="onSubmit">
      <!-- 姓名 :disabled="disabledName" -->
      <van-field
        v-model="form.name"
        name="name"
        label="真实姓名"
        placeholder="真实姓名"
        required
        :rules="[{ required: true, message: '请填写真实姓名' }]"
      />
      <!-- 性别 :disabled="disabledSex" -->
      <van-field name="sex" label="性别" required>
        <template #input>
          <van-radio-group
            v-model="form.sex"
            direction="horizontal">
            <van-radio name="1" value="1">男</van-radio>
            <van-radio name="2" value="2">女</van-radio>
          </van-radio-group>
        </template>
      </van-field>

      <!-- 证件类型 -->
      <van-field
        readonly
        clickable
        name="type"
        label="证件类型"
        placeholder="点击选择证件类型"
        required
        v-model="form.type"
        @click="showType = true"
      />
      <van-popup v-model="showType" position="bottom">
        <van-picker
          show-toolbar
          :columns="typeArr"
          @confirm="onType"
          @cancel="showType = false"
          @change="onChange"
        />
      </van-popup>

      <!-- 证件号码 v-if="!form.number" :disabled="disabledNumber" -->
      <van-field
        v-model="form.number"
        name="number"
        label="证件号码"
        placeholder="证件号码"
        @change="onNumberChange($event)"
        
        required
        :rules="[{ pattern, required: true, message: '请填写证件号码' }]"
      />

      <!-- <div v-if="form.number" class="van-cell van-cell--required van-field van-field--disabled">
        <div class="van-cell__title van-field__label">
          <span>证件号码</span>
        </div>
        <div class="van-cell__value van-field__value">
          <div class="van-field__body">
            {{form.number}}
          </div>
        </div>
      </div> -->
      

      <van-field
        v-model="form.birthday"
        is-link
        readonly
        name="birthday"
        label="出生年月日"
        :disabled="disabledNumber"
        placeholder="点击选择出生年月日"
        @click="showPicker = true"
        :rules="[{ required: true, message: '请选择出生年月日' }]"
      />
      
      <van-popup v-if="!form.birthday"  v-model="showPicker" position="bottom">
        <van-datetime-picker
          type="date"
          title="选择出生年月日"
          :min-date="minDate"
          :max-date="maxDate"
          @confirm="onConfirm"
          @cancel="showPicker = false"
        />
      </van-popup>

      <!-- 手机号码 -->
      <van-field
        v-model="form.tel"
        name="tel"
        label="手机号码"
        placeholder="手机号码"
        :disabled="disabledTel"
        required
        :rules="[
          {
            pattern: allPattern['mobile'],
            required: true,
            message: '请填写手机号码',
          },
        ]"
      />
      <!-- 血型 -->
      <van-field
        readonly
        clickable
        name="bloodType"
        label="血型"
        placeholder="点击选择血型"
        required
        v-model="form.bloodType"
        @click="showBloodType = true"
      />
      <van-popup v-model="showBloodType" position="bottom">
        <van-picker
          show-toolbar
          :columns="bloodTypeArr"
          @confirm="onBloodType"
          @cancel="showBloodType = false"
        />
      </van-popup>

      <!-- 衣服尺码 -->
      <van-field
        readonly
        clickable
        name="dressSize"
        label="衣服尺码"
        placeholder="点击选择衣服尺码"
        required
        v-model="form.dressSize"
        @click="showDressSize = true"
      />
      <van-popup v-model="showDressSize" position="bottom">
        <van-picker
          show-toolbar
          :columns="dressSizeArr"
          @confirm="onDressSize"
          @cancel="showDressSize = false"
        />
      </van-popup>
      <!-- 邮箱 -->
      <van-field
        v-model="form.email"
        name="email"
        label="邮箱"
        placeholder="邮箱"
        required
        :rules="[{ required: true, message: '请填写邮箱地址' }]"
      />
      <!-- 紧急联系人 -->
      <van-field
        v-model="form.contactsName"
        name="contactsName"
        label="紧急联系人"
        placeholder="紧急联系人"
        required
        :rules="[{ required: true, message: '请填写紧急联系人' }]"
      />
      <!-- 紧急联系人电话 -->
      <van-field
        v-model="form.contactsTel"
        name="contactsTel"
        label="紧急联系人电话"
        placeholder="紧急联系人电话"
        required
        :rules="[
          {
            pattern: allPattern['mobile'],
            required: true,
            message: '请填写正确的紧急联系人电话',
          },
        ]"
      />

      <!-- 快递邮寄地址（省市区） -->
      <van-field
        readonly
        clickable
        name="area"
        label="地区选择"
        placeholder="点击选择省市区"
        required
        :value="areaString"
        @click="showArea = true"
      />
      <van-popup v-model="showArea" position="bottom">
        <van-area
          :area-list="areaList"
          @confirm="onConfirmAddress"
          @cancel="showArea = false"
        />
      </van-popup>
      <!--  快递邮寄详细地址 value="340124"-->
      <van-field
        v-model="form.address"
        name="address"
        label="快递邮寄详细地址"
        placeholder="快递邮寄详细地址"
        required
        :rules="[{ required: true, message: '快递邮寄详细地址' }]"
      />

      <!-- 完赛证书 -->
      <van-field name="uploader" label="(选填)近期马拉松完赛证明">
        <template #input>
          <van-uploader
            v-model="uploader"
            max-count="1"
            :after-read="afterRead"
            result-type="dataUrl"
            :max-size="1024 * 1024"
            @oversize="onOversize"
          />
        </template>
      </van-field>

      <div style="margin: 16px">
        <van-button round block type="info" native-type="submit"
          >保存资料</van-button
        >
      </div>
    </van-form>
  </div>
</template>
<script>
import { areaList } from "@vant/area-data";
import { DatetimePicker, Dialog } from "vant";
import { fetchHttp, getQueryString } from "@/util/fn.js";

import {
  Button,
  Form,
  Field,
  Radio,
  RadioGroup,
  Checkbox,
  CheckboxGroup,
  Popup,
  Picker,
  Area,
  Uploader,
  SubmitBar,
  Toast,
} from "vant";

export default {
  name: "UserForm",
  props: {
    originForm: Object,
  },
  components: {
    [Button.name]: Button,
    [Form.name]: Form,
    [Field.name]: Field,
    [Radio.name]: Radio,
    [RadioGroup.name]: RadioGroup,
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup,
    [Popup.name]: Popup,
    [Picker.name]: Picker,
    [Area.name]: Area,
    [Uploader.name]: Uploader,
    [SubmitBar.name]: SubmitBar,
    [DatetimePicker.name]: DatetimePicker,
  },
  data() {
    return {
      minDate: new Date(1923, 0, 1),
      maxDate: new Date(2023, 0, 1),
      showPicker: false,
      allPattern: {
        身份证:
          /^[1-9]\d{5}(18|19|20|(3\d))\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/,
        护照: /^([a-zA-z]|[0-9]){5,17}$/,
        其他: /^([a-zA-z]|[0-9]){5,18}$/,
        mobile: /^1[3456789]\d{9}$/,
      },
      pattern:
        /^[1-9]\d{5}(18|19|20|(3\d))\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/,
      userId: Cookies.get("USERID"),
      areaString: "", //浙江省/杭州市/西湖区
      areaList: areaList,
      bloodTypeArr: ["A", "B", "AB", "O", "其他"],
      dressSizeArr: ["S", "M", "L", "XL", "2XL", "3XL", "4XL"],
      typeArr: ["身份证", "护照", "其他"],
      showArea: false, //地址popup的显示
      showBloodType: false, //血型popup的显示
      showDressSize: false, //衣服大小popup的显示
      showType: false, //护照类型popup的显示
      uploader: [], //{ url: "https://img01.yzcdn.cn/vant/leaf.jpg" }
      disabledName: false,
      disabledSex: false,
      disabledNumber: false,
      // disabledEdit: getQueryString("disabledEdit"),
      disabledTel: false,
      disabledType: false,
      form: {
        birthday: "",
        name: "", //真实姓名
        sex: "1",
        bloodType: "", //血型
        dressSize: "",
        type: "", //证件类型
        number: "", //身份证号码
        tel: "",
        contactsName: "",
        contactsTel: "",
        nationality: "中国",
        province: "浙江省",
        city: "杭州市",
        county: "西湖区",
        address: "",
        url: "", //完赛证书
        email: "", //我的资料页面有 邮箱，报名页面没有
      },
    };
  },
  mounted() {
    //获取基本信息
    fetchHttp("marathon/getUserInfo", { id: this.userId }, "GET").then(
      (res) => {
        if (res && res.code === 0) {
          let data = res.data;
          if (data) {
            //名字
            if (data.name) {
              this.disabledName = true;
            }
            
            //手机
            if (data.tel) {
              this.disabledTel = true;
            }

            //证件类别
            if(data.type){
              this.disabledType = true;
            }

            if (data.number) {
              this.disabledNumber = true;
            }

            this.pattern = this.allPattern[data.type];


            if (data.sex) {
              this.disabledSex = true;
            }

            this.userName = data.username;
            data.sex = String(data.sex);
            if (data.province && data.city && data.county) {
              this.areaString =
                data.province + "/" + data.city + "/" + data.county;
            }
            this.uploader = data.url && data.url !== "undefined" ? [{ url: data.url }] : [];
            Object.assign(this.form, data);
            console.log("原始数据信息", this.form);
          }
        }
      }
    );
  },
  methods: {
    formatSfzNumber(number){
      let birthdayNum = number.slice(6, 10) + "-" + number.slice(10, 12) +  "-" + number.slice(12, 14);
      return birthdayNum;
    },
    birthdayNo(){
      let birthdayNo = '';
      if(this.form.type === '身份证'){
        birthdayNo = this.form.birthday ? this.form.birthday : this.formatSfzNumber(this.form.number)
      }
      return birthdayNo;
    },
    onNumberChange(event){
      if(this.allPattern['身份证'].test(event.target.value)){
        this.form.birthday =  this.formatSfzNumber(event.target.value);
      }
    },
    getDate(date) {
      var time = new Date(date);
      var year = time.getFullYear(); //年
      var month = ("0" + (time.getMonth() + 1)).slice(-2); //月
      var day = ("0" + time.getDate()).slice(-2); //日
      var mydate = year + "-" + month + "-" + day;
      return mydate;
    },
    onConfirm(value) {
      this.form.birthday = this.getDate(value);
      this.showPicker = false;
    },
    onOversize(file) {
      Toast("完赛证明图片大小不能超过 1MB");
    },
    onBloodType(value) {
      this.form.bloodType = value;
      this.showBloodType = false;
    },
    onDressSize(value) {
      this.form.dressSize = value;
      this.showDressSize = false;
    },
    onType(value) {
      this.form.type = value;
      this.showType = false;
      this.pattern = this.allPattern[value];
    },
    //更改证件类型
    onChange(all, value) {
      this.form.type = value;
      this.pattern = this.allPattern[value];
    },
    onConfirmAddress(values) {
      this.areaString = values
        .filter((item) => !!item)
        .map((item) => item.name)
        .join("/");
      console.log(this.areaString);
      this.showArea = false;
    },
    //表单验证通过时的提交
    onSubmit(values) {
      console.log("form 中的数据", values);

      //校验省市区
      if (this.areaString.length < 1) {
        Toast("请正确选择省市区！");
        return;
      }

      let url = values.uploader && values.uploader[0] && values.uploader[0].url;
      //校验健康证明
      // if (!url) {
      //   Toast.fail("请上传近期内马拉松完赛证书！");
      //   return;
      // }

      var areaArr = this.areaString.split("/");
      let postData = Object.assign(this.form, {
        nationality: "中国",
        province: areaArr[0],
        city: areaArr[1],
        county: areaArr[2],
        userId: this.userId,
        url: url,
      });

      if(values && values.birthday === ''){
        Toast.fail("请选择您的出生年月日，方便后期保险的购买！");
        return false;
      }

      if (values && values.number && values.type === '身份证') {
        let birthdayNum =  values.number.slice(6,10) + '-' + values.number.slice(10,12) + '-' + values.number.slice(12,14);
        if(birthdayNum !== values.birthday){
          Toast('检测到您填写的出生年月日与身份证上不相符，你仔细检查修改后再提交！')
          return false;
        }
      }
      console.log("提交数据", postData);
      fetchHttp("marathon/userInfo", postData, "GET").then((res) => {
        if (res && res.code === 0) {
          Toast.success("个人资料修改成功！");
          setTimeout(() => {
            window.location.reload();
          }, 2000);
        } else {
          Dialog.alert({
            title: "请填写正确的资料",
            message: res.message,
          })
          //Toast.fail(res.message);
        }
      });
    },

    // 完赛证的 文件上传
    afterRead(file) {
      file.status = "uploading";
      file.message = "上传中...";

      //处理请求参数
      let formData = new FormData();
      formData.append("file", file.file);

      let postUrl = "http://ccfmty.com/marathon/picture";

      let postData = {
        method: "POST",
        credentials: "include",
        headers: {
          Accept: "*/*",
          token: Cookies.get("FMTY_TOKEN"),
        },
        body: formData,
      };
      let _self = this;
      window
        .fetch(postUrl, postData)
        .then(function (response) {
          return response.json();
        })
        .then(function (res) {
          if (res.code === 0 && res.data) {
            let url = '';
            if( res.data && res.data.includes('马拉松') ){
              url =  "http://ccfmty.com/marathon" + res.data;
            }else{
              url = res.data;
            }

            _self.uploader = url ? [{ url: url }] : [];
          } else if (
            res.code === 300003 ||
            res.code === 300000 ||
            res.code === 300002
          ) {
            alert("登录失效，请您去登录！");
            setTimeout(() => {
              window.location.href =
                "user" +
                "?redirect_url=" +
                encodeURIComponent(window.location.href);
            }, 2500);
          } else {
            file.status = "failed";
            file.message = "上传失败";
          }
        });
    },
  },
};
</script>